import React from 'react';
import { RegularMetricId } from '../../../../api/types-graphql';
import { ExternalChartComponentProps } from '../../../../common/components/data-viz-containers/common/types';
import { MultiMetricComparisonViz } from '../../../../common/components/data-viz-containers/multi-metric-comparison/MultiMetricComparisonViz';
import {
  MultiMetricComparisonVizConfig,
  MultiMetricComparisonVizViews,
} from '../../../../common/components/data-viz-containers/multi-metric-comparison/types';
import { defaultChartColors } from '../../../../common/components/ui-components/data-viz-ui/charts/common/common-chart-utils/common-chart-styles';
import { Languages } from '../../../../constants';
import { SingleValueTimeSelection } from '../../../../types';

interface NewGradRecruitmentFunnelChartProps {
  timeSelection: SingleValueTimeSelection;
  externalProps: ExternalChartComponentProps;
}

const NEW_GRAD_FILTER = `APPLICATION.CUSTOM_FILTER_1 = '新卒'`;

export const NewGradRecruitmentFunnelChart: React.FC<
  NewGradRecruitmentFunnelChartProps
> = (props) => {
  const { timeSelection, externalProps } = props;

  const multiMetricConfig: MultiMetricComparisonVizConfig = {
    title: {
      [Languages.EN]: 'Recruitment Funnel',
      [Languages.JA]: '採用ファネル',
    },
    timeSelection,
    queries: [
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0252_2ApplicationsCount,
        },
        label: {
          [Languages.EN]: 'Applications',
          [Languages.JA]: '応募',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0256_1ApplicationsAtScreeningCount,
        },
        label: {
          [Languages.EN]: 'Screening',
          [Languages.JA]: 'ES&適性検査',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0260_1ApplicationsAt_1stInterviewCount,
        },
        label: {
          [Languages.EN]: '1st Interview',
          [Languages.JA]: '1次面接',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0264_1ApplicationsAt_2ndInterviewCount,
        },
        label: {
          [Languages.EN]: '2nd Interview',
          [Languages.JA]: '最終面接',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0272_1ApplicationsAtOfferCount,
        },
        label: {
          [Languages.EN]: 'Offer',
          [Languages.JA]: '内定',
        },
      },
      {
        metric: {
          type: 'RegularMetricId' as const,
          value: RegularMetricId.Pm0276_1ApplicationsAtHiredCount,
        },
        label: {
          [Languages.EN]: 'Hired',
          [Languages.JA]: '内定受諾率',
        },
      },
    ],
    filters: NEW_GRAD_FILTER,
    isHorizontal: true,
    chartColors: defaultChartColors,
  };

  return (
    <MultiMetricComparisonViz
      dataConfig={multiMetricConfig}
      selectedView={MultiMetricComparisonVizViews.BAR_CHART}
      externalProps={externalProps}
      persistenceKey="new-grad-recruitment-funnel-chart-v2"
    />
  );
};
